import React from 'react';
import Container from '../../../Components/Container';
import './logicPro.css';

const Collaboration = () => {
  return (
    <section className="logicpro_collab_section">
      <Container>
        <p className="logicpro_collaborationTexts">
          Welcome all. We are proud to be the Title Sponsors at Alma Fiesta
          2022, and the official workshop partners at Alma Fiesta, IIT
          bhubaneswar. At the conclusion of this workshop, two certificates will
          be provided, one by Alma Fiesta, IIT bhubaneswar and one by Alien
          Brains Educations.
        </p>
        <p className="logicpro_collaborationTexts">
          We have always thrived for a mentorship model, where it’s always
          coupled with live projects and study materials. The series of
          workshops is aimed to get you ‘meaningfully started’ across these
          topics and leave you at a point from where you know how and from where
          to further explore more.
        </p>
      </Container>
    </section>
  );
};

export default Collaboration;



// WEBPACK FOOTER //
// ./src/Pages/SummerInternships/LogicPro/Collaboration.js